var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingCall2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.667A17.3 17.3 0 0011.333 16l2.444-2.444a.885.885 0 011.111-.222 11.622 11.622 0 004 .667A1.05 1.05 0 0120 15.111v3.778A1.05 1.05 0 0118.889 20 18.873 18.873 0 010 1.111 1.05 1.05 0 011.111 0H5a1.05 1.05 0 011.111 1.111 12.583 12.583 0 00.667 4 1.368 1.368 0 01-.222 1.111z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingCall2);
export default __webpack_public_path__ + "static/media/floating-call-2.5801519e37d122516eeeb2031eaede8e.svg";
export { ForwardRef as ReactComponent };